import React, { useState } from 'react'
import { push } from '@lagunovsky/redux-react-router'
import { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import useTitle from 'utils/customHook/useTitle'
import useActions from 'utils/customHook/useActions'
import SearchTable from 'referencial/components/SearchTable'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import ProgressCard from 'components/card/ProgressCard'
import { CONTRIBUTOR_LINK, PATH_REFERENCIAL_CONTRIBUTORS_GROUP_NEW, PATH_REFERENCIAL_LINK, PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'
import ContributorAction from '../actions/ContributorAction'
import PropTypes from 'prop-types'

const headers = ['id', 'name', 'siren', 'numberOfMembers']

const ContributorsGroupsApp = ({ rpqs }) => {
    const {
        contributorsGroups,
    } = useSelector(store => ({
        contributorsGroups: store.ContributorReducer.contributorsGroups,
    }), shallowEqual)

    const [dataLoaded, setDataLoaded] = useState(false)
    const [exportData, setExportData] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(ContributorAction.fetchContributorsGroups()).then(() => setDataLoaded(true))
    }, [])

    useTitle(() => {
        if (rpqs) {
            return [{
                title: i18n.rpqs,
                href: 'rpqs',
            }, {
                title: i18n.RPQSReferencials,
                href: PATH_REFERENCIAL_RPQS_LINK,
            }, {
                title: i18n.contributorsGroups,
                href: PATH_REFERENCIAL_RPQS_LINK + CONTRIBUTOR_LINK,
            }]
        }
        return [{
            title: i18n.referencials,
            href: 'referencial',
        }, {
            title: i18n.contributorsGroups,
            href: '/referencial/contributor',
        }]
    }, [rpqs])

    useActions(() => {
        return {
            new: () => dispatch(push(rpqs ? `${PATH_REFERENCIAL_RPQS_LINK}contributorGroup/new` : PATH_REFERENCIAL_CONTRIBUTORS_GROUP_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(exportData, headers),
                        titleFile: i18n.contributorsGroups,
                    },
                },
            },
        }
    }, [exportData, rpqs])

    const contributorsGroupsFormatted = useMemo(() => contributorsGroups.map(val => ({
        ...val,
        id: val.code,
        numberOfMembers: `${val.numberOfMembers}`,
    })), [contributorsGroups])

    if (!dataLoaded) {
        return <ProgressCard indeterminate withMessage round />
    }

    return (
        <SearchTable
            title={i18n.contributorsGroups}
            sessionKey={REFERENCIAL_TYPE_NAME.contactGroup}
            data={contributorsGroupsFormatted}
            setExportData={setExportData}
            headers={headers}
            onClick={contributorGroup => dispatch(push(`${rpqs ? PATH_REFERENCIAL_RPQS_LINK : PATH_REFERENCIAL_LINK}contributorGroup/${contributorGroup.id}/dashboard`))}
        />
    )
}

ContributorsGroupsApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default ContributorsGroupsApp